<div class="row">
  <div class="col-12">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('faqs_intro')"
        [innerHTML]="translationService.getTranslation('faqs_intro')"></h3>
  </div>
  <div class="col-12">
    <h4 [innerHTML]="translationService.getTranslation('faqs_summary')"></h4>
  </div>

  <ng-container *ngFor="let group of faqGroups">
    <app-faqgroup [faqGroup]="group"></app-faqgroup>
  </ng-container>
</div>
